module.exports = __webpack_public_path__ + "img/DSC_7701.a81cdc78.jpg";